import React, { Fragment } from 'react';

const ReviewItem = ({ questionNumber, data }) => {
  return (
    <Fragment>
      <h3 className="review-question-header">Question {questionNumber}</h3>
      {data}
    </Fragment>
  );
};

export default ReviewItem;



// WEBPACK FOOTER //
// ../core/src/components/ReviewSheet/ReviewItem.js